"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.digitalWorkerRoutes = void 0;
const digitalWorkerActions_openapi_1 = require("./digitalWorkerActions.openapi");
exports.digitalWorkerRoutes = [
    {
        name: 'digital-worker.proxy',
        path: ['/proxy'],
        method: 'POST',
        plugins: {
            openapi: digitalWorkerActions_openapi_1.digitalWorkerOpenApiDocs['digital-worker.proxy']
        }
    },
    {
        name: 'digital-worker.proxy-upload',
        path: ['/proxy-upload'],
        method: 'POST',
        plugins: {
            openapi: digitalWorkerActions_openapi_1.digitalWorkerOpenApiDocs['digital-worker.proxy-upload']
        }
    },
    {
        name: 'digital-worker.create-user',
        path: ['/create-user'],
        method: 'POST',
        plugins: {
            openapi: digitalWorkerActions_openapi_1.digitalWorkerOpenApiDocs['digital-worker.create-user']
        }
    },
];
